import React from 'react';
import AppBar from '../../commons/AppBar'
import ButtonsModules from '../../commons/ButtonsModules';
import { Divider, Grid, FormControl, InputLabel, Select, Input, MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import FromServer from './FromServer';
import { TopButtons } from '../../commons/TopButtons';
import BalanteBilanturi from './BalanteBilanturi';
import AnalizeClienti from './Analize';

export default class IstoricIndicatoriFinanciari extends SpecificComponent {
    constructor(props) {
      super(props);
    
       this.state = {
        nrIndicator:this.props.startFrom + 1,
        listIndicatori:[],
        listIstoric:[],
        possibleOutcome: null,
        luna:'',
        nrYear:'',
        listYears: new Utils().getLast10Years(),
            listMonths: new Utils().getMonths,
            strValoare:'',
          
}
    }

     componentDidMount(){
         this.getIndicatori()
        //  this.props.openBalanta(this.openBalantaRef)
        //  this.props.openBilant(this.openBilantRef)
    }

 

    getIndicatori = async() =>{
       
        let fs = new FromServer();

        let u = new Utils()

        let _getIndicatori =  fs.getIndicatoriIstoric( this.props.startFrom + 1)

        let _getData =  fs.getIndicatoriFinanciar(this.props.startFrom + 1)

        let [getIndicatori,getData] = await Promise.all([_getIndicatori, _getData])

        // console.log('getIndicatori :', getIndicatori);



        if(getIndicatori.r && getData.r){

            let iF = [...getIndicatori.c.listIndicatori]


            let newObj = []

            for(let i = this.props.startFrom , n = this.props.length || iF.length; i< n ; i++){
                newObj.push({id:iF[i].id,  label:iF[i].simbol, color:u.culoriTopButtons(i)})
            }

        //   console.log('newObj :', newObj);

        //   console.log('this.startFrom :', this.props.startFrom + 1);
            let idx=  newObj.findIndex(i =>i.id === (this.props.startFrom + 1))
            // console.log('idx :', idx);

            this.setState({
                listIndicatori:newObj,
                indicatorSelectat:newObj[idx].label,
                listIstoric:getIndicatori.c.listIstoric,
                possibleOutcome: getData.c.possibleOutcome
            })
        }

           
        


    }

    onIndicatorSelect = async(b)=>{

        if(b !== 'bilanturi_balante'){
            let fs = new FromServer();

            let _getIndicatori =  fs.getIndicatoriIstoric( b)

        let _getData =  fs.getIndicatoriFinanciar(b)

        let [getIndicatori,getData] = await Promise.all([_getIndicatori, _getData])
     
            if(getIndicatori.r && getData.r){

                let indicatori = [...this.state.listIndicatori]

                let idx=  indicatori.findIndex(i => i.id === b)


    
                this.setState({listIstoric:getIndicatori.c.listIstoric,
                    indicatorSelectat:indicatori[idx].label,
                    possibleOutcome:getData.c.possibleOutcome,
                    nrIndicator:b})
            }
        }else{
            this.setState({ nrIndicator:b})
        }
      
       
        
    }

    addIndicator = async() =>{

      let obj =  {id_indicator:this.state.nrIndicator, 
            an:this.state.nrYear,
        luna:this.state.luna,
        valoare:this.state.strValoare}

        let fs = new FromServer();


        let addIndicator = await fs.addIndicatorIstoric(obj)
               if(addIndicator.r){
                   this.getIndicatori()
               }                                                         
    }


    deleteIndicator = async(i) =>{
        // console.log('i :', i);
    }

    openBilantRef = (b) =>{

        this.setState({nrIndicator:'bilanturi_balante'},()=>{
            this.goToBilant(b)

        })
        // console.log('b :', b);
       
    }


    openBalantaRef = (b) =>{

        // console.log('b :', b);

        this.setState({nrIndicator:'bilanturi_balante'},()=>{
            this.goToBalanta(b)

        })
    }
     render() { 
       return (
          <div>
        

                <Divider className="pm-divider" />

                  <Grid className='container' style={{ position: 'relative', justifyContent:'center' }} container>



            {this.state.listIndicatori.map((b,idx) =>{
                return(
                    <Grid key={idx } style={{ width: 'fit-content', marginTop: 10 }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                    {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
                    <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
                    <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
                */}

                    <TopButtons
                        b={b}
                        buttonSelected={this.onIndicatorSelect}
                        buttonSelectat={this.state.nrIndicator}
                        />

                     
                           
     

                         </Grid>
                )
            })}

            </Grid>

                    {/* {this.state.nrIndicator === 'bilanturi_balante' &&
                                <BalanteBilanturi  goToBalanta ={b => this.goToBalanta = b}
                                                     goToBilant = {bi => this.goToBilant = bi}
                                />
                    } */}

      
      {this.state.listIndicatori &&
   <h2 style={{margin:'auto'}} className = 'pm-title'>{this.state.indicatorSelectat}</h2>}
                     {this.state.possibleOutcome !== null &&
                                <Grid className='container' container style={{ marginTop: 20, justifyContent:'center' }}>
                                    
                                    <Grid style={{ width: '50%', border: '1px dashed gray' }} item xs={12} sm={12} md={6} lg={6} xl={6} >

                                        <h4 className='pm-title'>Previziune</h4>
                                        <span style={{ color: 'green' }}>{new Date().getFullYear()}.{new Utils().getMonths[new AnalizeClienti   ().addMonths(new Date(new Date().setMonth(this.state.listIstoric[0].luna -1 )), +1).getMonth()].luna}: {this.state.possibleOutcome} </span>

                                    </Grid>
                                </Grid>

                            }
                {this.state.nrIndicator !=='bilanturi_balante' &&
          
               <Grid className='container' style={{ position: 'relative' }} container>

                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} >
                            {/* <FormControl className='inputFocus' style={{ width: '30%', marginTop: 20 }}>
                                <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaIndicator}</InputLabel>
                                <Select

                                    value={this.state.nrIndicator || ""}
                                    onChange={(ev) => { this.onIndicatorSelect(ev)}}

                                    input={<Input id="resursa" />}>


                                    {this.state.listIndicatori.map((s, idx) => {
                                        return <MenuItem value={s.id} key={idx}  > {s.simbol}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl> */}


                        </Grid>

                        {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaLuna}</InputLabel>
                            <Select

                                value={this.state.luna || ""}
                                onChange={(ev) => { this.setState({luna:ev.target.value}) }}

                                input={<Input id="resursa" />}>


                                {this.state.listMonths.map((s, idx) => {
                                    return <MenuItem value={s.id} key={idx}  > {s.luna}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                         <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaAnul}</InputLabel>
                            <Select

                                value={this.state.nrYear || ""}
                                onChange={(ev) => { this.setState({nrYear:ev.target.value}) }}

                                input={<Input id="resursa" />}>


                                {this.state.listYears.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.dictionary.financiarContabil.valoare}
                                    value={this.state.strValoare || ''}
                                    onChange={(ev)=>{this.setState({strValoare:ev.target.value})}}
                                    margin="normal"
                                
                                />

                            </Grid>

                            <Grid style={{ width: 'fit-content'}} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Button onClick={this.addIndicator} 
                            style={{ width: 'fit-content',
                                color:'white',
                                    backgroundColor:'rgba(0, 194, 255, 0.8)' }}  variant="contained">{this.dictionary.comune.add}</Button>
                       
                    </Grid> */}


                    {this.state.listIstoric.length > 0 &&

         
                    <Table>
                       <TableHead>
                           <TableRow>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                               {this.dictionary.financiarContabil.nume}
                               </TableCell>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                               {this.dictionary.financiarContabil.anul}
                               </TableCell>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                               {this.dictionary.financiarContabil.luna}
                               </TableCell>
                               <TableCell style={{fontSize:14, fontWeight:600}}>
                               {this.dictionary.financiarContabil.valoare}
                               </TableCell>

                           </TableRow>
                       </TableHead>

                       <TableBody>
                           {this.state.listIstoric.map((l,idx)=>{
                               return(
                                   <TableRow key={idx}>
                                       <TableCell >
                                        {l.simbol}
                                       </TableCell>
                                       <TableCell >
                                           {l.an}
                                           </TableCell>
                                           <TableCell >
                                           {new Utils().getMonths[Number(l.luna) - 1].luna}
                                           </TableCell>
                                           <TableCell >
                                           {l.valoare}
                                           </TableCell>
                                           {/* <TableCell >
                                           <i style={{color:'#f33838', cursor:'pointer'}} onClick={()=>{this.deleteIndicator(l)}} className='material-icons'>delete</i>
                                           </TableCell> */}
                                   </TableRow>
                               )
                           })}
                       </TableBody>
                   </Table>
                    }
                        



                  </Grid>

               }
         </div>
        );
       }
}